export default "__VITE_ASSET__BLV8UqVJ__"